import { cn } from "@/lib/utils";

const MAP = {
  // percorso / stato
  Attivo: "bg-[#E8F5E9] text-[#1E5E2B] border-[#A5D6A7]",
  Svolta: "bg-[#E8F5E9] text-[#1E5E2B] border-[#A5D6A7]",
  Pagato: "bg-[#E8F5E9] text-[#1E5E2B] border-[#A5D6A7]",
  "In pausa": "bg-[#FFF8E1] text-[#8D6E63] border-[#FFE082]",
  "Da ricontattare": "bg-[#FFF8E1] text-[#8D6E63] border-[#FFE082]",
  "In esaurimento": "bg-[#FFF8E1] text-[#8D6E63] border-[#FFE082]",
  Pianificata: "bg-[#E6EFEA] text-[#234735] border-[#B7D3C4]",
  "Parzialmente pagato": "bg-[#FFF8E1] text-[#8D6E63] border-[#FFE082]",
  Esaurito: "bg-[#FFEBEE] text-[#C62828] border-[#EF9A9A]",
  "Non pagato": "bg-[#FFEBEE] text-[#C62828] border-[#EF9A9A]",
  Concluso: "bg-[#F5F5F5] text-[#616161] border-[#E0E0E0]",
  Annullata: "bg-[#F5F5F5] text-[#616161] border-[#E0E0E0]",
};

export const StatusBadge = ({ value, testid }) => {
  const cls = MAP[value] || "bg-[#F5F5F5] text-[#616161] border-[#E0E0E0]";
  return (
    <span
      data-testid={testid}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        cls
      )}
    >
      {value}
    </span>
  );
};

// Owner-level CRM contact stage badge (independent from operational status).
const CONTACT_MAP = {
  "Da conoscere": "bg-[#E3F2FD] text-[#1565C0] border-[#90CAF9]",
  "Da ricontattare": "bg-[#FFF8E1] text-[#8D6E63] border-[#FFE082]",
  "Occasionale": "bg-[#F3E5F5] text-[#6A1B9A] border-[#CE93D8]",
  "Cliente": "bg-[#E8F5E9] text-[#1E5E2B] border-[#A5D6A7]",
  "Chiuso": "bg-[#F5F5F5] text-[#616161] border-[#E0E0E0]",
};

export const ContactBadge = ({ value, testid }) => {
  const v = value || "Cliente";
  const cls = CONTACT_MAP[v] || CONTACT_MAP["Cliente"];
  return (
    <span data-testid={testid}
      className={cn("inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap", cls)}>
      Contatto: {v}
    </span>
  );
};
